import { render, staticRenderFns } from "./PatientModal.vue?vue&type=template&id=65c8ed4d&"
import script from "./PatientModal.vue?vue&type=script&lang=js&"
export * from "./PatientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports